import Head from 'next/head'
import styles from "../styles/pages/Home.module.scss"
import Topbanner from '../components/Topbanner/Topbanner'


export default function CovidPolicy() {
    return (
        <>
            <Head>
                <title>The Twin Towers Hotel in Kufri, Shimla| Covid Policy Page</title>
                <meta name="description" content=" Explore our COVID-19 policies, hotel arrival procedures, elevated guest services, and meticulous sanitization protocols at The Twin Towers Hotel." />
                <link rel="icon" href="/favicon.svg" />
            </Head>
            <Topbanner bgImage={"/images/terms-banner.png"} title={"COVID Policy"} />
            <section className={`${styles.privacy_policy} common_padding`}>
                <div className='container'>
                    <div className='common_title'>
                        <h2>Policies & safety measures for COVID are below:</h2>
                        <p>Reservations and Admission:</p>
                        <ul>
                            <li>Admission to The Twin Towers Hotel  is subject to submission of Covid final vaccination certificate (vaccination validity is 280 days from the date of last vaccination)</li>
                            <li>If unvaccinated, partially vaccinated, or vaccination is outside of the validity period, guests must submit an RT-PCR test conducted not earlier than 72 hours from the time of arrival at The Twin Towers Hotel.</li>
                            <li>Guests are advised to also independently verify the updated regulations as listed on the Indian government and Himachal Pradesh State government websites and take appropriate action to adhere to these guidelines. The Twin Towers Hotel does not take any responsibility or liability for changes in these regulations.</li>

                        </ul>
                        <h3>Arrival at Hotel:</h3>
                        <ul>
                            <li>Hotel cars are sanitized using safe sanitizing procedures before each trip.</li>
                            <li>Sanitising products are available in the car.</li>
                            <li>Automatic hand sanitizer is available at locations across the premises.</li>

                        </ul>
                        <h3>Guest Services and Sanitization Measures:</h3>
                        <ul>
                            <li>All rooms surfaces and public areas are sanitized regularly with safe disinfecting chemicals</li>
                            <li>After a thorough cleaning of the room, all the areas and surfaces are carefully sanitized</li>
                            <li>All ventilation and air-conditioning units in rooms are cleaned and sanitized frequently using FOG machines.</li>
                            <li>All amenities, linen, and glassware used in rooms are sanitized
                                High-temperature washing of all crockery and silverware used in restaurant and other dining venues.</li>
                        </ul>
                        <h3>The Twin Towers Hotel Team :</h3>
                        <ul>
                            <li>All  staff members wear a Face Mask while on hotel premises</li>
                            <li>Daily thermal check for all staff members is done along with regular health screenings</li>
                            <li>All ventilation and air-conditioning units in rooms are cleaned and sanitized frequently using FOG machines.</li>
                            <li>Out staff members are fully vaccinated</li>
                        </ul>
                    </div>
                </div>
            </section>
        </>
    )
}
